import { __exports as e } from "./index132.js";
var r;
function d() {
  if (r) return e;
  r = 1, Object.defineProperty(e, "__esModule", { value: !0 });
  var t = {
    Salesforce: !0
  };
  function u(a) {
    return !t[a];
  }
  return e.default = u, e;
}
export {
  d as __require
};
//# sourceMappingURL=index110.js.map
